import { useMutation } from '@apollo/client';

import { CreateEventInput } from '../../apollo/__generated__/graphql';
import { EVENTS } from '../../event/graphql/query/eventsQuery.graphql';
import { CREATE_EVENT } from '../graphql/mutation/createEventMutation.graphql';

export const useCreateEventMutation = (
  onCompleted: (eventId: string) => void,
) => {
  const [mutate] = useMutation(CREATE_EVENT, {
    onCompleted: ({ createEvent: { id } }) => onCompleted(id),
  });

  const createEvent = (createEventInput: CreateEventInput) => {
    mutate({
      variables: {
        createEventInput,
      },
      refetchQueries: [EVENTS],
    });
  };

  return { createEvent };
};
